import clsx from 'clsx';
import { useContextSystem } from '../../context';
import styles from '../style.module.scss';
export function useItemGroup(props) {
  const {
    className,
    isBordered = false,
    isRounded = true,
    isSeparated = false,
    role = 'list',
    ...otherProps
  } = useContextSystem(props, 'ItemGroup');
  const classes = clsx(styles['item-group'], {
    [styles['is-bordered']]: isBordered,
    [styles['is-separated']]: isSeparated,
    [styles['is-rounded']]: isRounded
  }, className);
  return {
    isBordered,
    className: classes,
    role,
    isSeparated,
    ...otherProps
  };
}